export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PrimaryButton.vue?vue&type=template&id=27f519b4&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PrimaryButton.vue?vue&type=template&id=27f519b4&scoped=true&
// module id = 257
// module chunks = 0